import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { debitsSelectedComp, registerDebitAutomaticComp } from "../../actions";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  label: {
    width: "100%",
    display: "flex",
    cursor: "pointer"
  },
  checkbox: {
    position: "absolute"
  },
  cotasInput: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2
  },
  disabledItem: {
    background: "#dcdcdccc",
    width: "100%",
    height: 32,
    position: "absolute",
    zIndex: 9,
  }
});

class SwitchTableAutomaticDebit extends Component {
  constructor() {
    super();
    this.state = { value: false };
  }

  componentDidMount(){
    if(this.props.typeSwitch === "changeQuotas"){
      this.setState({ value: this.props.opQuotas })
    }
  }

  handleChange = event => {
    let obj = this.props.registerDebitAutomaticValue;
    this.setState({ value: event.target.checked });

    //True é COTAS - False é COTAS ÚNICAS
    if (event.target.checked) {
      //se clicou em cotas, remove o elemento de cotas unicas
      for (let i = 0; i < obj.CotasUnicas.length; i++) {
        if (obj.CotasUnicas[i] === event.target.value.toString()) {
          obj.CotasUnicas.splice(i, 1);
        }
      }
      obj.Cotas.push(event.target.value);
    } else {
      for (let i = 0; i < obj.Cotas.length; i++) {
        if (obj.Cotas[i] === event.target.value.toString()) {
          obj.Cotas.splice(i, 1);
        }
      }
      obj.CotasUnicas.push(event.target.value);
    }
    this.props.registerDebitAutomaticComp(obj);
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div>
      <div className="track">
        {!this.props.allowQuotas &&
          <div className={classes.disabledItem}></div>
        }
        <label className={classes.label}>
          <input
            onChange={this.handleChange}
            value={this.props.idItem}
            type="checkbox"
            className={classes.checkbox}
          />
          <div className={`${value ? "off" : "on"} ${classes.cotasInput}`}>
            <p>COTAS ÚNICAS</p>
          </div>
          <div className={`${value ? "on" : "off"} ${classes.cotasInput}`}>
            <p>COTAS</p>
          </div>
        </label>
      </div>
      {!this.props.allowQuotas &&
        <p style={{textAlign: "center"}}>Este item não permite cotas</p>
      }
      </div>
    );
  }
}

const mapStateToProps = store => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  registerDebitAutomaticValue: store.cardDebitState.registerDebitAutomaticValue
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { debitsSelectedComp, registerDebitAutomaticComp },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SwitchTableAutomaticDebit)
);
